/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ticketSubsidyControllerCreateTicketSubsidy } from '../fn/ticket-subsidy/ticket-subsidy-controller-create-ticket-subsidy';
import { TicketSubsidyControllerCreateTicketSubsidy$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-create-ticket-subsidy';
import { ticketSubsidyControllerDeleteTicketSubsidy } from '../fn/ticket-subsidy/ticket-subsidy-controller-delete-ticket-subsidy';
import { TicketSubsidyControllerDeleteTicketSubsidy$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-delete-ticket-subsidy';
import { ticketSubsidyControllerFindByTicketId } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-by-ticket-id';
import { TicketSubsidyControllerFindByTicketId$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-by-ticket-id';
import { ticketSubsidyControllerFindLogById } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-log-by-id';
import { TicketSubsidyControllerFindLogById$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-log-by-id';
import { ticketSubsidyControllerFindLogsByTicketId } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-logs-by-ticket-id';
import { TicketSubsidyControllerFindLogsByTicketId$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-logs-by-ticket-id';
import { ticketSubsidyControllerFindPrevTicketSubsidy } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-prev-ticket-subsidy';
import { TicketSubsidyControllerFindPrevTicketSubsidy$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-find-prev-ticket-subsidy';
import { ticketSubsidyControllerForceCreate } from '../fn/ticket-subsidy/ticket-subsidy-controller-force-create';
import { TicketSubsidyControllerForceCreate$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-force-create';
import { ticketSubsidyControllerUpdateTicketSubsidy } from '../fn/ticket-subsidy/ticket-subsidy-controller-update-ticket-subsidy';
import { TicketSubsidyControllerUpdateTicketSubsidy$Params } from '../fn/ticket-subsidy/ticket-subsidy-controller-update-ticket-subsidy';
import { TicketSubsidyDto } from '../models/ticket-subsidy-dto';
import { TicketSubsidyLogDto } from '../models/ticket-subsidy-log-dto';

@Injectable({ providedIn: 'root' })
export class TicketSubsidyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ticketSubsidyControllerFindLogsByTicketId()` */
  static readonly TicketSubsidyControllerFindLogsByTicketIdPath = '/api/ticket-subsidy';

  /**
   * 서비스 ID로 이월/소멸 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerFindLogsByTicketId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindLogsByTicketId$Response(params: TicketSubsidyControllerFindLogsByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TicketSubsidyLogDto>>> {
    return ticketSubsidyControllerFindLogsByTicketId(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 ID로 이월/소멸 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerFindLogsByTicketId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindLogsByTicketId(params: TicketSubsidyControllerFindLogsByTicketId$Params, context?: HttpContext): Observable<Array<TicketSubsidyLogDto>> {
    return this.ticketSubsidyControllerFindLogsByTicketId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TicketSubsidyLogDto>>): Array<TicketSubsidyLogDto> => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerCreateTicketSubsidy()` */
  static readonly TicketSubsidyControllerCreateTicketSubsidyPath = '/api/ticket-subsidy';

  /**
   * 이월 내역 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerCreateTicketSubsidy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketSubsidyControllerCreateTicketSubsidy$Response(params: TicketSubsidyControllerCreateTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
    return ticketSubsidyControllerCreateTicketSubsidy(this.http, this.rootUrl, params, context);
  }

  /**
   * 이월 내역 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerCreateTicketSubsidy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketSubsidyControllerCreateTicketSubsidy(params: TicketSubsidyControllerCreateTicketSubsidy$Params, context?: HttpContext): Observable<TicketSubsidyDto> {
    return this.ticketSubsidyControllerCreateTicketSubsidy$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyDto>): TicketSubsidyDto => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerFindByTicketId()` */
  static readonly TicketSubsidyControllerFindByTicketIdPath = '/api/ticket-subsidy/ticket';

  /**
   * 서비스 ID로 현재 지원금 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerFindByTicketId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindByTicketId$Response(params: TicketSubsidyControllerFindByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
    return ticketSubsidyControllerFindByTicketId(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 ID로 현재 지원금 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerFindByTicketId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindByTicketId(params: TicketSubsidyControllerFindByTicketId$Params, context?: HttpContext): Observable<TicketSubsidyDto> {
    return this.ticketSubsidyControllerFindByTicketId$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyDto>): TicketSubsidyDto => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerFindPrevTicketSubsidy()` */
  static readonly TicketSubsidyControllerFindPrevTicketSubsidyPath = '/api/ticket-subsidy/prev';

  /**
   * 이전달의 지원금 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerFindPrevTicketSubsidy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindPrevTicketSubsidy$Response(params: TicketSubsidyControllerFindPrevTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
    return ticketSubsidyControllerFindPrevTicketSubsidy(this.http, this.rootUrl, params, context);
  }

  /**
   * 이전달의 지원금 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerFindPrevTicketSubsidy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindPrevTicketSubsidy(params: TicketSubsidyControllerFindPrevTicketSubsidy$Params, context?: HttpContext): Observable<TicketSubsidyDto> {
    return this.ticketSubsidyControllerFindPrevTicketSubsidy$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyDto>): TicketSubsidyDto => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerFindLogById()` */
  static readonly TicketSubsidyControllerFindLogByIdPath = '/api/ticket-subsidy/{id}';

  /**
   * ID로 이월/소멸 내역 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerFindLogById()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindLogById$Response(params: TicketSubsidyControllerFindLogById$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyLogDto>> {
    return ticketSubsidyControllerFindLogById(this.http, this.rootUrl, params, context);
  }

  /**
   * ID로 이월/소멸 내역 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerFindLogById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerFindLogById(params: TicketSubsidyControllerFindLogById$Params, context?: HttpContext): Observable<TicketSubsidyLogDto> {
    return this.ticketSubsidyControllerFindLogById$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyLogDto>): TicketSubsidyLogDto => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerDeleteTicketSubsidy()` */
  static readonly TicketSubsidyControllerDeleteTicketSubsidyPath = '/api/ticket-subsidy/{id}';

  /**
   * 이월 내역 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerDeleteTicketSubsidy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerDeleteTicketSubsidy$Response(params: TicketSubsidyControllerDeleteTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyLogDto>> {
    return ticketSubsidyControllerDeleteTicketSubsidy(this.http, this.rootUrl, params, context);
  }

  /**
   * 이월 내역 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerDeleteTicketSubsidy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketSubsidyControllerDeleteTicketSubsidy(params: TicketSubsidyControllerDeleteTicketSubsidy$Params, context?: HttpContext): Observable<TicketSubsidyLogDto> {
    return this.ticketSubsidyControllerDeleteTicketSubsidy$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyLogDto>): TicketSubsidyLogDto => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerUpdateTicketSubsidy()` */
  static readonly TicketSubsidyControllerUpdateTicketSubsidyPath = '/api/ticket-subsidy/{id}';

  /**
   * 이월 내역 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerUpdateTicketSubsidy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketSubsidyControllerUpdateTicketSubsidy$Response(params: TicketSubsidyControllerUpdateTicketSubsidy$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyLogDto>> {
    return ticketSubsidyControllerUpdateTicketSubsidy(this.http, this.rootUrl, params, context);
  }

  /**
   * 이월 내역 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerUpdateTicketSubsidy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketSubsidyControllerUpdateTicketSubsidy(params: TicketSubsidyControllerUpdateTicketSubsidy$Params, context?: HttpContext): Observable<TicketSubsidyLogDto> {
    return this.ticketSubsidyControllerUpdateTicketSubsidy$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyLogDto>): TicketSubsidyLogDto => r.body)
    );
  }

  /** Path part for operation `ticketSubsidyControllerForceCreate()` */
  static readonly TicketSubsidyControllerForceCreatePath = '/api/ticket-subsidy/force';

  /**
   * 이월 내역 강제 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketSubsidyControllerForceCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketSubsidyControllerForceCreate$Response(params: TicketSubsidyControllerForceCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
    return ticketSubsidyControllerForceCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 이월 내역 강제 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketSubsidyControllerForceCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketSubsidyControllerForceCreate(params: TicketSubsidyControllerForceCreate$Params, context?: HttpContext): Observable<TicketSubsidyDto> {
    return this.ticketSubsidyControllerForceCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketSubsidyDto>): TicketSubsidyDto => r.body)
    );
  }

}
